const Default = {
  maxSnack: 3,
  tokenKey: 'oauthToken',
  refreshKey: 'refreshToken',
  expiryKey: 'expiry',
  autoHideDuration: 3000,
};

export default Default;
